module.exports = __webpack_public_path__ + "media/application/images/placeholder/placeholder-b86b365f5997a5eaf40e09432e3df8ff.jpg";